import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';

import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import unCheckedIconLight from './images/unCheckedIcon-Light.svg';
import checkedIconLight from './images/checkedIcon-Light.svg';
import unCheckedIconDark from './images/unCheckedIcon-Dark.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	width: 420,
	display: 'flex',
	marginTop: token('space.150', '12px'),
	marginBottom: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled.div({
	paddingTop: token('space.150', '12px'),
	paddingRight: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapper = styled.div({
	width: 40,
	paddingRight: token('space.200', '16px'),
	paddingTop: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	width: 364,
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextAreaTitle = styled.div({
	fontSize: 14,
	fontStyle: 'normal',
	fontWeight: 700,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextAreaBody = styled.div({
	fontSize: 14,
	fontStyle: 'normal',
	fontWeight: 400,
});

export enum CheckIconStatus {
	CHECKED,
	UNCHECKED,
	NOT_RENDERED,
}

export type ListItemProps = {
	bodyText: MessageDescriptor;
	darkImg: string;
	img: string;
	title: MessageDescriptor;
	checkIconStatus?: CheckIconStatus;
};

export const ListItem = ({
	img,
	darkImg,
	title,
	bodyText,
	checkIconStatus = CheckIconStatus.NOT_RENDERED,
}: ListItemProps) => {
	return (
		<Wrapper>
			{checkIconStatus === CheckIconStatus.UNCHECKED && (
				<IconWrapper>
					<Image src={unCheckedIconLight} srcDark={unCheckedIconDark} testId="unchecked-icon" />
				</IconWrapper>
			)}
			{checkIconStatus === CheckIconStatus.CHECKED && (
				<IconWrapper>
					<Image src={checkedIconLight} testId="checked-icon" />
				</IconWrapper>
			)}
			<ImageWrapper>
				<Image src={img} srcDark={darkImg} />
			</ImageWrapper>
			<ContentWrapper>
				<TextAreaTitle>
					<FormattedMessage {...title} />
				</TextAreaTitle>
				<TextAreaBody>
					<FormattedMessage {...bodyText} />
				</TextAreaBody>
			</ContentWrapper>
		</Wrapper>
	);
};
